<ng-container [ngSwitch]="deviceType()">
	<div class="pwa-prompt" *ngSwitchCase="'default'" [ngClass]="{'prompt-visible':promptVisible()}">
		<div *ngIf="installationAvailable()">
			<div class="container-fluid">
				<div class="row p-3">
					<div class="col-12">
						<h5>{{translate('PWA_INSTALLER_LINE1_ANDROID')}}</h5>
					</div>
				</div>
				<div class="row p-3">
					<div class="col-12">
						{{translate('PWA_INSTALLER_LINE2_ANDROID')}}
					</div>
					
				</div>
				<div class="row">
						<div class="col-1 col-md-2"></div>
						<div class="col-5 col-md-4">
							<button class="p-2 m-2 btn btn-small btn-info bg-sdbg-red sdbg-font" style="width:100%;" (click)="install()">{{translate('PWA_INSTALLER_CONFIRM')}}</button>
						</div>
						<div class="col-5 col-md-4">
							<button class="p-2 m-2 btn btn-small btn-info bg-sdbg-red sdbg-font" style="width:100%;" (click)="promptDismissed = true;">{{translate('PWA_INSTALLER_DENY')}}</button>
						</div>
						<div class="col-1"></div>
					<div class="col-3"></div>				
				</div>
				<div class="row">
					<div class="col-2 col-md-8"></div>
					<div class="col-8 col-md-4 small text-right"><a href="https://de.wikipedia.org/wiki/Progressive_Web_App#Add-To-Homescreen" target="_blank">{{translate('PWA_INSTALLER_INFO')}}</a></div>
				</div>
			</div>
		</div>
	</div>
	<div class="pwa-prompt iphone" *ngSwitchCase="'iphone'" [ngClass]="{'prompt-visible':promptVisible()}">
		<div *ngIf="installationAvailable()">
			<div class="container-fluid">
				<div class="row">
					<div class="col-2"><span class="pwa-add-to-homescreen-ios-button">&nbsp;</span></div>
					<div class="col-10">
						<!--
							<span class="safari-share-icon">&nbsp;</span>
						-->
						<small>{{translate('PWA_INSTALLER_IPHONE_MSG',0)}}<span class="pwa-safari-share-icon">&nbsp;</span>{{translate('PWA_INSTALLER_IPHONE_MSG',1)}}</small>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="pwa-prompt ipad" *ngSwitchCase="'ipad'" [ngClass]="{'prompt-visible':promptVisible()}">
		<div *ngIf="installationAvailable()">
			<div class="container-fluid">
				<div class="row">
					<div class="col-2"><span class="pwa-add-to-homescreen-ios-button">&nbsp;</span></div>
					<div class="col-10">
						<small>{{translate('PWA_INSTALLER_IPAD_MSG',0)}}<span class="pwa-safari-share-icon">&nbsp;</span>{{translate('PWA_INSTALLER_IPAD_MSG',1)}}</small>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
